module.exports = __webpack_public_path__ + "img/sooth-banner.0c6bf610.png";